import { render, staticRenderFns } from "./validasi.vue?vue&type=template&id=ad0da7ea&scoped=true&lang=html&"
import script from "./validasi.vue?vue&type=script&lang=js&"
export * from "./validasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0da7ea",
  null
  
)

export default component.exports